<template>
    <div>
        <v-row>
            <v-col cols="12" md="6">
                <v-select id="salutation-field" :label="`${$t('login.fields.labels.name.salutation')} *`" :items="[$t('login.fields.salutations.ms'), $t('login.fields.salutations.mr'), $t('login.fields.salutations.diverse')]" v-model="salutation" @input="$emit('input', JSON.stringify(result))" :rules="rules"></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field id="title-field" :label="`${$t('login.fields.labels.name.title')}`" v-model="title" @input="$emit('input', JSON.stringify(result))"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-text-field id="firstname-field" :label="`${$t('login.fields.labels.name.first_name')} *`" v-model="firstName" @input="$emit('input', JSON.stringify(result))" :rules="rules"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field id="lastname-field" :label="`${$t('login.fields.labels.name.last_name')} *`" v-model="lastName" @input="$emit('input', JSON.stringify(result))" :rules="rules"></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'NameField',
        data:()=>({
            salutation: null,
            title: null,
            firstName: null,
            lastName: null,
        }),
        computed: {
            result(){
                return {
                    salutation: this.salutation,
                    title: this.title,
                    firstName: this.firstName,
                    lastName: this.lastName,
                }
            },
            rules() {
                return [
                    v => !!v || this.$t('login.fields.rules.required')
                ]
            }
        }
    };
</script>

<style scoped>

</style>